import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import Paper from '@mui/material/Paper';
import SearchIcon from '@mui/icons-material/Search';
import * as XLSX from 'xlsx';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { IconButton } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';
import FeedIcon from '@mui/icons-material/Feed';
import Select from 'react-select'; // Import react-select
import AsyncSelect from 'react-select/async';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

function CashBook() {
    const [dataBill, setDataBill] = useState([]);
    const [dataItem, setDataItem] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const tableRef = React.createRef();
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [selectedOption, setSelectedOption] = useState('itemWise');
    const [customerOptions, setCustomerOptions] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [customerId, setCustomer] = useState('');
    const { isAuthenticated, companyId, branchId, userId, permissions, companyName, token, logout, username, branchstate } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
        fetchTableData();
        //fetchCustomerData();
    }, [isAuthenticated, companyId, token, branchId, logout]);

    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    const getFormattedStartDate = () => {
        const today = new Date();
        let year = today.getFullYear();

        if (today.getMonth() + 1 > 3) {
            // If the current month is greater than 3, use the current year
            return `${year}-04-01`;
        } else {
            // If the current month is 3 or less, use the previous year
            return `${year - 1}-04-01`;
        }
    };

    //FOR CHILD 
    const [ChildOptions, setchildOptions] = useState([]);
    const [selectedChildOption, setSelectedChildOption] = useState(null);

    const fetchChildOptions = async (inputValue) => {
        if (inputValue.length <= 3) {
            return [];
        }

        try {
            const response = await fetchData('JournelEntryAPI', `/Master/${companyId}/${inputValue}`, token);
            if (response.responseCode === '1111') {
                const data = await response.response_data;
                if (Array.isArray(data)) {
                    setchildOptions(data); // Save the options for later use
                    return data.map(item => ({
                        value: item.Id,
                        label: item.Name,
                    }));
                } else {
                    console.error('Data is not an array:', data);
                    return [];
                }
            } else {
                console.error('Unexpected response code:', response.responseCode);
                return [];
            }
        } catch (error) {
            console.error('Error fetching options:', error);
            return [];
        }
    };

    const handleChildInputChange = (newValue) => newValue;

    // Handle customer selection
    const handleChildSelect = (selectedChildOption) => {
        setSelectedChildOption(selectedChildOption);
    };

    const fetchTableData = async () => {
        setDataItem([])
        try {
            const response = await fetchData('ReportApi', `/CashBook/${fromDate}/${toDate}/${companyId}`, token);
            if (response.responseCode === '1111') {
                setDataItem(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Packing Slip Details:', error);
        }

    };

    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        setFromDate(selectedDate);
    };

    // Similar function for toDate
    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        setToDate(selectedDate);
    };

    const hasReadReportPermission = permissions.includes('Read Reports');

    const handleChange = (event) => {
        setSelectedOption(event.target.value);
    };

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredDataBill = dataBill.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const filteredDataItem = dataItem.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };

    // const handleExportExcel = () => {
    //     const excelData = [];
    //     let copbal = 0;
    //     let dopbal = 0;
    //     let bal = 0;

    //     // Helper function to compute balance
    //     const computeBalance = (data) => {
    //         if (data.description1 !== 'Closing Balance' && data.description1 !== 'Total') {
    //             // Add debit to balance
    //             if (data.debit) {
    //                 bal += Math.abs(data.debit);
    //             }
    //             // Subtract credit from balance
    //             if (data.credit) {
    //                 bal -= Math.abs(data.credit);
    //             }
    //         }

    //         // Return balance string with "Dr" or "Cr"
    //         //data.description1 !== 'Opening Balance' &&
    //         if (data.description1 !== 'Closing Balance' && data.description1 !== 'Total') {
    //             return bal > 0 ? `${bal.toFixed(2)} Dr` : `${Math.abs(bal).toFixed(2)} Cr`;
    //         }
    //         return '';
    //     };

    //     // Ensure selectedCustomer is handled properly
    //     const customerLabel = selectedChildOption ? selectedChildOption.label : 'Cash Book';
    //     const now = new Date();
    //     const formattedDateTime = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;

    //     // Add header caption
    //     const headerCaption = [
    //         [`Cash Book From: ${formatDate(fromDate)} To: ${formatDate(toDate)} | Generated On: ${formattedDateTime} By : ${username}`]
    //     ];
    //     excelData.push(...headerCaption);

    //     // Add column headers
    //     const headerRow = ['Date', 'Description', 'Debit', 'Credit', 'Balance'];
    //     excelData.push(headerRow);

    //     // Add data rows
    //     filteredDataItem.forEach((rowData) => {
    //         const dataRow = [];
    //         if (rowData.description1 === 'Opening Balance') {
    //             // Display balances under Debit and Credit columns
    //             dataRow.push(
    //                 '', // Empty date
    //                 rowData.description1,
    //                 rowData.debit != null ? rowData.debit.toFixed(2) : '',
    //                 rowData.credit != null ? rowData.credit.toFixed(2) : '',
    //                 computeBalance(rowData)
    //             );

    //         } else if (rowData.description1 === 'Closing Balance') {
    //             // Display Total directly under Debit and Credit columns
    //             dataRow.push(
    //                 '', // Empty date
    //                 rowData.description1,
    //                 rowData.debit != null ? rowData.debit.toFixed(2) : '',
    //                 rowData.credit != null ? rowData.credit.toFixed(2) : '',
    //                 '' // No balance for Total rows
    //             );
    //         }

    //         else if (rowData.description1 === 'Total') {
    //             // Display Total directly under Debit and Credit columns
    //             dataRow.push(
    //                 '', // Empty date
    //                 rowData.description1,
    //                 rowData.debit != null ? rowData.debit.toFixed(2) : '',
    //                 rowData.credit != null ? rowData.credit.toFixed(2) : '',
    //                 '' // No balance for Total rows
    //             );
    //         } else {
    //             // For regular rows
    //             dataRow.push(
    //                 formatDate(rowData.billdate), // Format the date
    //                 rowData.description1,
    //                 rowData.debit != null ? parseFloat(rowData.debit.toFixed(2)) : '',
    //                 rowData.credit != null ? parseFloat(rowData.credit.toFixed(2)) : '',
    //                 computeBalance(rowData) // Compute and add balance
    //             );
    //         }
    //         excelData.push(dataRow);
    //     });

    //     // Create a worksheet
    //     const worksheet = XLSX.utils.aoa_to_sheet(excelData);

    //     // Style the worksheet to right-align specific columns
    //     const columnIndexesToRightAlign = [2, 3, 4]; // Debit, Credit, and Balance columns
    //     const range = XLSX.utils.decode_range(worksheet['!ref']);

    //     for (let row = 1; row <= range.e.r; row++) { // Start from row 1 (skip header)
    //         columnIndexesToRightAlign.forEach((colIndex) => {
    //             const cellAddress = XLSX.utils.encode_cell({ r: row, c: colIndex });
    //             if (worksheet[cellAddress]) {
    //                 worksheet[cellAddress].s = { alignment: { horizontal: 'right' } };
    //             }
    //         });
    //     }

    //     // Create workbook and add the worksheet
    //     const workbook = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(workbook, worksheet, 'Cash Book');

    //     // Filename sanitization for spaces and special characters
    //     const sanitizedCustomerLabel = customerLabel.replace(/[^\w]/g, '_');
    //     XLSX.writeFile(workbook, `Cash_Book_From_${formatDate(fromDate).replace(/[/]/g, '-')}_To_${formatDate(toDate).replace(/[/]/g, '-')}.xlsx`);
    // };

    const handleExportExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Cash Book');
        worksheet.views = [
            { state: 'frozen', xSplit: 0, ySplit: 2 } // fixed header
        ];
        let bal = 0;

        const computeBalance = (data) => {
            if (data.description1 !== 'Closing Balance' && data.description1 !== 'Total') {
                if (data.debit) bal += Math.abs(data.debit);
                if (data.credit) bal -= Math.abs(data.credit);
            }

            if (data.description1 !== 'Closing Balance' && data.description1 !== 'Total') {
                return bal > 0 ? `${bal.toFixed(2)} Dr` : `${Math.abs(bal).toFixed(2)} Cr`;
            }

            return '';
        };

        const now = new Date();
        const formattedDateTime = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;
        const customerLabel = selectedChildOption ? selectedChildOption.label : 'Cash Book';
        const fileName = `Cash_Book_From_${formatDate(fromDate).replace(/\//g, '-')}_To_${formatDate(toDate).replace(/\//g, '-')}.xlsx`;

        // Title row
        const caption = `${companyName} - Cash Book From: ${formatDate(fromDate)} To: ${formatDate(toDate)} | Generated On: ${formattedDateTime} By: ${username}`;
        worksheet.mergeCells('A1:E1');
        const titleCell = worksheet.getCell('A1');
        titleCell.value = caption;
        titleCell.font = { bold: true, size: 10 };
        titleCell.alignment = { vertical: 'middle', horizontal: 'left' };

        // Header row
        const headers = ['Date', 'Description', 'Debit', 'Credit', 'Balance'];
        const headerRow = worksheet.addRow(headers);

        const thinBorder = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
        };

        headerRow.eachCell((cell) => {
            cell.font = { bold: true };
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFB6D7A8' } };
            cell.alignment = { vertical: 'middle', horizontal: 'center' };
            cell.border = thinBorder;
        });

        // Data rows
        filteredDataItem.forEach((rowData) => {
            let rowValues;

            if (rowData.description1 === 'Opening Balance' || rowData.description1 === 'Closing Balance' || rowData.description1 === 'Total') {
                rowValues = [
                    '', // Date
                    rowData.description1,
                    rowData.debit != null ? rowData.debit.toFixed(2) : '',
                    rowData.credit != null ? rowData.credit.toFixed(2) : '',
                    rowData.description1 === 'Opening Balance' ? computeBalance(rowData) : ''
                ];
            } else {
                rowValues = [
                    formatDate(rowData.billdate),
                    rowData.description1,
                    rowData.debit != null ? rowData.debit.toFixed(2) : '',
                    rowData.credit != null ? rowData.credit.toFixed(2) : '',
                    computeBalance(rowData)
                ];
            }

            const row = worksheet.addRow(rowValues);

            row.eachCell((cell, colNumber) => {
                // Apply alignment and borders
                if ([3, 4, 5].includes(colNumber)) {
                    cell.alignment = { vertical: 'middle', horizontal: 'right' };
                    cell.numFmt = '#,##0.00';
                } else {
                    cell.alignment = { vertical: 'middle', horizontal: 'left' };
                }
                cell.border = thinBorder;
            });


            if (rowData.description1 === 'Closing Balance' || rowData.description1 === 'Total') {
                row.eachCell((cell) => {
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'FFF4CCCC' }, // Light pink
                    };
                    cell.font = { bold: true };
                    cell.border = thinBorder;
                    cell.alignment = { horizontal: 'right', vertical: 'middle', wrapText: true };
                });
            } else {
                row.eachCell((cell, colNumber) => {
                    if ([3, 4, 5].includes(colNumber)) {
                        cell.alignment = { horizontal: 'right' };
                        cell.numFmt = '#,##0.00';
                    } else {
                        cell.alignment = { horizontal: 'left' };
                    }
                    cell.border = thinBorder;
                });
            }
        });

        // Auto column width
        worksheet.columns = [
            { width: 14 }, // Date
            { width: 35 }, // Description
            { width: 15 }, // Debit
            { width: 15 }, // Credit
            { width: 20 }  // Balance
        ];

        // Export the file
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]), fileName);
    };


    let copbal = 0;
    let dopbal = 0;
    let bal = 0;

    const computeBalance = (data) => {
        if (data.description1 !== 'Closing Balance' && data.description1 !== 'Total') {
            // Add debit to balance
            if (data.debit) {
                bal += Math.abs(data.debit);
            }
            // Subtract credit from balance
            if (data.credit) {
                bal -= Math.abs(data.credit);
            }
        }

        // Return balance string with "Dr" or "Cr"
        if (data.description1 !== 'Closing Balance' && data.description1 !== 'Total') {
            return bal > 0 ? `${bal.toFixed(2)} Dr` : `${Math.abs(bal).toFixed(2)} Cr`;
        }
        return '';
    };

    const [page, setPage] = useState(0); // Current page
    const [rowsPerPage, setRowsPerPage] = useState(15); // Rows per page


    // Handle page change
    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    // Handle rows per page change
    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0); // Reset to the first page
    };


    const processedData = filteredDataItem.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
    );




    return (
        <div className="w-full mx-auto" style={{ width: '95%', marginTop: '-10px', fontFamily: 'Segoe UI, sans-serif' }}>

            {/* Header Section */}
            <div className="w-full mb-4 flex justify-between items-center">
                <div
                    style={{
                        background: "whitesmoke",
                        color: "black",
                        padding: "5px 10px",
                        borderTopLeftRadius: "6px",
                        borderTopRightRadius: "6px",
                        fontSize: "12px",
                        fontWeight: "bold",
                        letterSpacing: "0.5px",
                        marginTop: '-30px',
                        height: '30px'
                    }}
                >
                    CASH BOOK
                </div>

                <div className="flex flex-wrap gap-2 items-center">

                    {/* From Date */}
                    <div className="flex items-center gap-2">
                        <label className="text-gray-700 text-sm">From</label>
                        <input
                            type="date"
                            value={fromDate}
                            onChange={handleFromDateChange}
                            className="border border-gray-300 rounded px-2 py-1 text-sm shadow-sm focus:outline-none focus:ring-1 focus:ring-blue-400"
                        />
                    </div>

                    {/* To Date */}
                    <div className="flex items-center gap-2">
                        <label className="text-gray-700 text-sm">To</label>
                        <input
                            type="date"
                            value={toDate}
                            onChange={handleToDateChange}
                            className="border border-gray-300 rounded px-2 py-1 text-sm shadow-sm focus:outline-none focus:ring-1 focus:ring-blue-400"
                        />
                    </div>

                    {/* Buttons */}
                    <Button
                        onClick={fetchTableData}
                        style={{
                            background: "#2f4050",
                            color: "white",
                            borderRadius: "4px",
                            padding: "5px 12px",
                            fontSize: "13px",
                            fontWeight: "bold",
                            height: "28px",
                        }}
                    >
                        Refresh
                    </Button>

                    {/* Excel */}
                    <Button
                        onClick={handleExportExcel}
                        style={{
                            background: "#00695c",
                            color: "white",
                            borderRadius: "4px",
                            padding: "5px 12px",
                            fontSize: "13px",
                            fontWeight: "bold",
                            height: "28px",
                        }}
                    >
                        Excel
                    </Button>
                </div>
            </div>

            {/* Table Section */}
            <div className="w-full" style={{ maxHeight: '550px', overflowY: 'auto', marginTop: '-20px' }}>
                <TableContainer component={Paper} sx={{ boxShadow: '0 4px 10px rgba(0,0,0,0.1)' }}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#2E3B33' }}>
                            <TableRow>
                                {['Date', 'Description', 'Debit', 'Credit', 'Balance'].map((col) => (
                                    <TableCell
                                        key={col}
                                        sx={{
                                            color: 'black',
                                            fontWeight: 'bold',
                                            fontSize: '11px',
                                            textTransform: 'uppercase',
                                            padding: '3px',
                                            borderBottom: 'none',
                                            backgroundColor: '#edf1efff'
                                        }}
                                        align={col === 'Date' || col === 'Description' ? 'left' : 'right'}
                                    >
                                        {col}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {processedData.map((data, index) => {
                                const isSpecialRow =
                                    data.description1 === 'Opening Balance' ||
                                    data.description1 === 'Closing Balance' ||
                                    data.description1 === 'Total';
                                return (
                                    <TableRow
                                        key={data.id}
                                        sx={{
                                            backgroundColor: index % 2 === 0 ? '#f9f9f9' : '#ffffff',
                                            '&:hover': { backgroundColor: '#e1f5fe' },
                                        }}
                                    >
                                        <TableCell sx={{ fontSize: '13px', padding: '6px' }}>
                                            {isSpecialRow ? '' : formatDate(data.billdate)}
                                        </TableCell>

                                        <TableCell
                                            sx={{
                                                fontSize: '13px',
                                                padding: '6px',
                                                fontWeight: isSpecialRow ? 'bolder' : 'normal',
                                            }}
                                        >
                                            {data.description1}
                                        </TableCell>

                                        <TableCell
                                            sx={{
                                                fontSize: '13px',
                                                padding: '6px',
                                                textAlign: 'right',
                                                fontWeight: isSpecialRow ? 'bolder' : 'normal',
                                            }}
                                        >
                                            {data.debit != null ? data.debit.toFixed(2) : ''}
                                        </TableCell>

                                        <TableCell
                                            sx={{
                                                fontSize: '13px',
                                                padding: '6px',
                                                textAlign: 'right',
                                                fontWeight: isSpecialRow ? 'bolder' : 'normal',
                                            }}
                                        >
                                            {data.credit != null ? data.credit.toFixed(2) : ''}
                                        </TableCell>

                                        <TableCell
                                            sx={{
                                                fontSize: '13px',
                                                padding: '6px',
                                                textAlign: 'right',
                                                fontWeight: 'bolder', // Keep balance always bold
                                            }}
                                        >
                                            {computeBalance(data)}
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>

                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[15, 25, 50, 100]}
                                    count={filteredDataItem.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handlePageChange}
                                    onRowsPerPageChange={handleRowsPerPageChange}
                                />
                            </TableRow>
                        </TableFooter>

                    </Table>
                </TableContainer>
            </div>
        </div>
    );
}

export default CashBook;
